var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFactory = function SvgIconFactory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16.5a1 1 0 0 1 1-1h2.625a1 1 0 1 1 0 2H7.5a1 1 0 0 1-1-1M12.875 16.5a1 1 0 0 1 1-1H16.5a1 1 0 1 1 0 2h-2.625a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.397 1.25h-.003a1.75 1.75 0 0 0-1.728 1.507v.002L13.64 9.92 10.35 7.45a1 1 0 0 0-1.6.8v2.5l-4.4-3.3a1 1 0 0 0-1.6.8v11H1.5a1 1 0 1 0 0 2h21a1 1 0 1 0 0-2h-1.25v-6.483a1 1 0 0 0-.012-.175l-1.404-9.833v-.002a1.75 1.75 0 0 0-1.728-1.507zm2.7 10.5-1.213-8.5h-1.268l-1.15 8.037.617.463zm-5.388.719q.078.073.172.129l1.269.952a1 1 0 0 0 .6.2h3.5v5.5H4.75v-9l4.4 3.3a1 1 0 0 0 1.6-.8v-2.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFactory;